import { getDataBase } from '../db';

export default class HistoricoFacturaDAL {
    
    async TraerHistorial(Cliente, DataBaseAlias) {
        // Abre la base de datos
        // Inicia una transacción de lectura
   
        try {
            const db = await getDataBase();
            const tx = db.transaction('HISTORICOFACTURA', 'readonly');
            const store = tx.objectStore('HISTORICOFACTURA');

            const index = store.index('Cliente');
            const facturas = await index.getAll(Number(Cliente));
            facturas.sort((a, b) => b.Cobro.localeCompare(a.Cobro));

            // Limitar a 11 facturas
            const facturasLimitadas = facturas.slice(0, 11);
            const resultado = facturasLimitadas.map(factura => ({
                Mes: factura.Cobro,
                Factura: factura.NumeroFactura,
                M3: factura.Consumo,
                MontoFactura: factura.Monto,
                FechaLectura: factura.FechaLectura,
                MedidorAnormalidad: factura.MedidorAnormalidad,
                FechaPago: factura.FacturaPago == "00/00/000" ? "  /  /    " : factura.FacturaPago,
                Estado: factura.Estado == 1 ? "Impaga" : "Pagado"
            }));

            tx.done;
            return resultado;
        } catch (error) {
            console.error('Error en TraerHistorial:', error);
            return [];
        }
    }


    async  GetFechaLecturaAnterior(tcCliente, DataBaseAlias) {
       
       try {
            // Abre la base de datos
            const db = await getDataBase();
            const tx = db.transaction('HISTORICOFACTURA', 'readonly');
            const store = tx.objectStore('HISTORICOFACTURA');
            const index = store.index('Cliente');
            const facturas = await index.getAll(Number(tcCliente));

            facturas.sort((a, b) => b.Factura - a.Factura);

            const fechaLecturaAnterior = facturas.length > 0 ? facturas[0] : [];
            const loR = [];
            loR.push(fechaLecturaAnterior);
            tx.done;
            return loR;
       } catch (error) {
            console.log('Error en GetFechaLecturaAnterior:', error);
            return [];
            
       }
    }


    // async historicoFacturaCantidad(){
    //     return [];
    // }
}